<h1 mat-dialog-title>Distribuciones de tiempo</h1>

<mat-dialog-content style="padding-top: 10px">
  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource" style="overflow: scroll; width: 100%">
        <ng-container matColumnDef="is_active">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let record">
            <span [matTooltip]="record.is_active ? 'Distribución acitva' : 'Distribución futura'">
              {{ record.is_active ? '🟢' : '🔵' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="start_date">
          <th mat-header-cell *matHeaderCellDef>Inicio</th>
          <td mat-cell *matCellDef="let record">
            <mat-form-field appearance="outline" style="padding: 10px 0">
              <input
                matInput
                [matDatepicker]="pickerStart"
                [(ngModel)]="record.start_date"
                [min]="record.minStartDate"
                [max]="record.maxStartDate"
                (dateChange)="updateDates(record)"
                [disabled]="record.is_active"
                [matDatepickerFilter]="isMonday"
              />

              <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
              <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="end_date">
          <th mat-header-cell *matHeaderCellDef>Fin</th>
          <td mat-cell *matCellDef="let record; let last = last" style="display: flex; gap: 2px">
            <mat-form-field appearance="outline" style="padding: 10px 0">
              <input
                matInput
                [matDatepicker]="pickerEnd"
                [(ngModel)]="record.end_date"
                [min]="record.minEndDate"
                [max]="record.maxEndDate"
                (dateChange)="updateDates(record)"
                [matDatepickerFilter]="isSunday"
                [errorStateMatcher]="past_date_error_state_matcher()"
              />

              <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>

              <mat-datepicker #pickerEnd></mat-datepicker>
            </mat-form-field>

            @if (last && record.end_date) {
              <button
                mat-icon-button
                matSuffix
                (click)="record.end_date = null; updateDates(record)"
                tabindex="-1"
                [matTooltip]="'Borrar fecha'"
                style="margin-top: 14px !important"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef>Fecha última modificación</th>
          <td mat-cell *matCellDef="let record">
            <mat-form-field appearance="outline" style="padding: 10px 0">
              <input matInput [matDatepicker]="pickerUpdatedAt" [(ngModel)]="record.updated_at" [disabled]="true" required />
              <mat-datepicker-toggle matSuffix [for]="pickerUpdatedAt"></mat-datepicker-toggle>
              <mat-datepicker #pickerUpdatedAt></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let record">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="compact-menu">
              @if (record.is_active) {
                <button mat-menu-item (click)="openViewRecordDialog(record)">
                  <mat-icon>visibility</mat-icon>
                  Ver
                </button>
              }

              <button mat-menu-item (click)="openEditRecordDialog(record)" [disabled]="!record.editable">
                <mat-icon>edit</mat-icon>
                Editar
              </button>

              <button mat-menu-item (click)="cloneRecord(record)">
                <mat-icon>content_copy</mat-icon>
                Clonar
              </button>

              <button mat-menu-item (click)="openDeleteRecordDialog(record)" [disabled]="record.is_active">
                <mat-icon>delete</mat-icon>
                Eliminar
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let last = last; columns: displayedColumns"></tr>
      </table>
    </div>
    @if (form.errors?.['pastDateWithSingleTimeDistribution']) {
      <mat-error class="hint-error">
        No se puede definir una fecha de fin anterior a la fecha actual, a menos que haya otra distribución de tiempo
      </mat-error>
    }
  </div>
</mat-dialog-content>
